import { Icons } from '@assets';
import { IAcl, INavMenuItem } from '@types';
import { isAllow } from '@utils/functions';

const { HeaderIcons } = Icons;

export const crm = (rules: IAcl | undefined): INavMenuItem[] => [
    {
        name: 'Клиенты ',
        desc: 'Клиенты ',
        icon: <img src={HeaderIcons.IconHeaderCrm} alt="icon crm" />,
        to: '/crm/clients',
        text: 'crm_clients',
        navKey: 'crm.clients',
        isAllow: isAllow(rules, 'crm.clients', 'w'),
        subs: [
            {
                name: 'Клиенты',
                to: '/crm/clients',
                text: 'crm_clients',
                navKey: 'crm.clients',
                isAllow: isAllow(rules, 'crm.clients', 'w'),
            },
        ],
    },
    {
        name: 'Журналы',
        desc: 'Журналы',
        icon: <img src={HeaderIcons.IconHeaderCrm} alt="icon crm" />,
        to: '/crm/transactions',
        text: 'crm_transactions',
        navKey: 'crm.transactions',
        isAllow: isAllow(rules, 'crm.clients', 'w'),
        subs: [
            {
                name: 'Транзакции',
                to: '/crm/transactions',
                text: 'crm_transactions',
                navKey: 'crm.transactions',
                isAllow: isAllow(rules, 'crm.logs', 'r'),
            },
        ],
    },

    {
        name: 'Маркетинг ',
        desc: 'Маркетинг ',
        icon: <img src={Icons.IconCalendarClockFill} alt="icon clock" />,
        to: '/crm/marketing',
        text: 'crm_marketing',
        navKey: 'crm.marketing',
        isAllow: isAllow(rules, 'crm.clients'),
        subs: [
            {
                name: 'Источники ',
                to: '/crm/clients_origins',
                text: 'crm_clients_origins',
                navKey: 'crm.marketing.origins',
                isAllow: isAllow(rules, 'crm.origins'),
            },
            {
                name: 'Посещения',
                to: '/crm/clients_visits',
                text: 'crm_clients_visits',
                navKey: 'crm.marketing.visits',
                isAllow: isAllow(rules, 'crm.visits'),
            },
            {
                name: 'Push-уведомления',
                to: '/crm/notify',
                text: 'crm_notify',
                navKey: 'crm.marketing.notify',
                isAllow: isAllow(rules, 'crm.notify'),
            },
            {
                name: 'Формы',
                to: '/crm/cards',
                text: 'crm_cards',
                navKey: 'crm.cards',
                isAllow: isAllow(rules, 'crm.cards', 'r'),
            },
        ],
    },
];

export default crm;
